import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { PortalId } from '../../utils/portal-id/portal-id.model';

@Injectable({
  providedIn: 'root',
})
export class TermsAndConditionsService {
  constructor(
    private httpClient: HttpClient,
    private translateService: TranslateService,
    @Inject('window') public window: Window,
  ) {}

  openFileInNewWindow(
    portalId: PortalId,
    customLanguage?: string,
  ): Subscription {
    const language = customLanguage || this.translateService.currentLang;
    const headers = new HttpHeaders().set('Accept', 'text/html');
    return this.httpClient
      .get(`/api/system/web/portal/${portalId}/regulamin/lang/${language}`, {
        responseType: 'text',
        headers,
      })
      .subscribe((termsAndConditionsHTML) => {
        const windowInstance = this.window.open('');
        windowInstance.document.write(termsAndConditionsHTML);
      });
  }
}
